import { render, staticRenderFns } from "./BrowseByStatues.vue?vue&type=template&id=44b0d6b7&"
import script from "./BrowseByStatues.vue?vue&type=script&lang=js&"
export * from "./BrowseByStatues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports